import { useState, useCallback, useEffect, } from 'react';
export function useField(initialValue, validator, options) {
    if (validator === void 0) { validator = function () { return null; }; }
    if (options === void 0) { options = {}; }
    var _a = useState(initialValue), value = _a[0], _setValue = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(false), shouldValidate = _c[0], setShouldValidate = _c[1];
    var validate = useCallback(function () {
        setShouldValidate(true);
        var hasError = validator(value);
        var error = options.error ? hasError && options.error : hasError;
        if (error) {
            setError(error);
            return false;
        }
        else {
            setError('');
            setShouldValidate(false);
            return true;
        }
    }, [options.error, validator, value]);
    useEffect(function () {
        _setValue(initialValue);
    }, [initialValue]);
    useEffect(function () {
        if (shouldValidate) {
            validate();
        }
    }, [shouldValidate, validate]);
    useEffect(function () {
        if (options.validate != null) {
            setShouldValidate(options.validate);
        }
    }, [options.validate]);
    var setValue = useCallback(function (value, _shouldValidate) {
        if (_shouldValidate != null) {
            setShouldValidate(_shouldValidate);
        }
        _setValue(value);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setState: _setValue,
        error: error,
        setError: setError,
        validate: validate,
        hasChanged: value !== initialValue,
    };
}
export function useValidators() {
    var validators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        validators[_i] = arguments[_i];
    }
    return useCallback(function (value) {
        for (var _i = 0, validators_1 = validators; _i < validators_1.length; _i++) {
            var validator = validators_1[_i];
            var error = validator(value);
            if (error)
                return error;
        }
        return null;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, validators);
}
//# sourceMappingURL=useField.js.map